import axios from "axios";
import {BASE_URL} from "../../constants/API";

export async function getMarketAnalysisHeader() {
    return await axios.get(BASE_URL + '/market-analysis-headers?populate=image');
}

export async function getMarketAnalysisDataContent() {
    return await axios.get(BASE_URL + '/market-analysis-data-contents?populate=video');
}